import styled from 'styled-components'

export const Panel = styled.section`
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px;
  margin-top: 8px;
`

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
`

export const Count = styled.span`
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 4.5px 8px;
  color: #363636;
  font-size: 14px;
  white-space: nowrap;
`

export const ToolbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`

export const ToolbarButton = styled.button`
  height: 32px;
  padding: 0 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #0085ff;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #dceefe;
  }

  &:disabled {
    color: #757575;
    cursor: default;
  }
`

export const AddButton = styled(ToolbarButton)`
  background: #e7f3fe;

  svg {
    margin-right: 6px;
  }

  &:hover:not(:disabled) {
    background: #dceefe;
    color: #0085ff;
  }
`
